(() => {
  const normalize = value => String(value || '').toLocaleLowerCase().replace(/\s+/g, ' ').trim();

  function readChoice(picker, index) {
    if (picker.tagName === 'VARIANT-RADIOS') {
      const group = picker.querySelectorAll('fieldset')[index];
      return { values: [...(group?.querySelectorAll('input[type="radio"]') || [])].map(input => input.value), selected: group?.querySelector('input:checked')?.value };
    }
    const select = picker.querySelectorAll('select')[index];
    return { values: [...(select?.options || [])].map(option => option.value), selected: select?.value };
  }

  function setGallery(section) {
    const picker = section.querySelector('variant-radios, variant-selects');
    if (!picker) return;
    const color = readChoice(picker, 0);
    if (!color.selected) return;
    const fit = readChoice(picker, 1);
    const fits = ['Classic', 'Slim', 'Athletic'];
    const selectedFit = fits.includes(fit.selected) ? fit.selected : null;
    const colors = [...color.values].sort((a, b) => b.length - a.length);
    const classify = alt => colors.find(value => normalize(alt).includes(normalize(value)));
    const fitsPhoto = alt => {
      if (!selectedFit) return true;
      const text = normalize(alt);
      const beforeColor = text.split(' in ')[0];
      const photoFit = fits.find(value => text.includes(`${normalize(value)} fit`) || beforeColor.endsWith(normalize(value)));
      return !photoFit || photoFit === selectedFit;
    };

    section.querySelectorAll('media-gallery').forEach(gallery => {
      const slides = [...gallery.querySelectorAll('.product__media-list > .product__media-item')];
      const matching = [];
      slides.forEach(slide => {
        const alt = slide.querySelector('img')?.alt || '';
        const visible = classify(alt) === color.selected && fitsPhoto(alt);
        slide.hidden = !visible;
        if (visible) matching.push(slide);
      });
      const targets = new Set(matching.map(slide => slide.dataset.mediaId));
      gallery.querySelectorAll('.thumbnail-list__item').forEach(item => { item.hidden = !targets.has(item.dataset.target); });
      if (!matching.length) return;
      slides.forEach(slide => slide.classList.toggle('is-active', slide === matching[0]));
      gallery.querySelectorAll('.thumbnail-list__item button').forEach(button => button.removeAttribute('aria-current'));
      const firstThumb = gallery.querySelector(`.thumbnail-list__item[data-target="${matching[0].dataset.mediaId}"] button`);
      firstThumb?.setAttribute('aria-current', 'true');
      const current = gallery.querySelector('.slider-counter--current');
      const total = gallery.querySelector('.slider-counter--total');
      if (current) current.textContent = '1';
      if (total) total.textContent = String(matching.length);
      requestAnimationFrame(() => {
        gallery.querySelector('[id^="GalleryViewer"]')?.initPages?.();
        gallery.querySelector('[id^="GalleryThumbnails"]')?.initPages?.();
        gallery.querySelector('.product__media-list')?.scrollTo({left: matching[0].offsetLeft, behavior: 'instant'});
      });
    });

    const modal = document.getElementById(`ProductModal-${section.dataset.section}`);
    modal?.querySelectorAll('.product-media-modal__content > *').forEach(media => {
      const alt = media.querySelector('img')?.alt || '';
      media.hidden = classify(alt) !== color.selected || !fitsPhoto(alt);
    });
  }

  const initialize = () => document.querySelectorAll('section[data-amm-gallery]').forEach(setGallery);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('change', event => {
    const section = event.target.closest('section[data-amm-gallery]');
    if (section && event.target.closest('variant-radios, variant-selects')) requestAnimationFrame(() => setGallery(section));
  });
})();
